module.exports = import("https://esm.sh/@vfx-js/core@0.5.1");;